import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * NOTE:
 * This is meant as a bridge between us and Galaxy
 * Once we migrate into the Galaxy repo, we can use <glxy-nav>
 */
@Component({
    selector: 'glxy-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
    /** Whether to automatically resize the nav panel whenever the size of any of its drawers changes **/
    @Input() navAutoSize: boolean = false;
    @Input() isNavOpen = true;
    @Input() navMode: 'over' | 'side' = 'side';
    @Input() fixedTopGap = 0; // to accommodate the Atlas Bar
    @Output() onClose = new EventEmitter();

    constructor() {}

    ngOnInit() {}

    public handleClose() {
        this.onClose.emit();
    }
}
